module.exports = __webpack_public_path__ + "static/logos-13-f970c0b74ca2dbb77ef467f499ff5d59.png";